module.exports = __webpack_public_path__ + "static/media/International Manufacturers and Distributors.14d3af7c.png";